function imageSlider() {
  var imageSlider = $(".js-image-slider");
  imageSlider.slick({
    dots: false,
    arrows: true,
    nextArrow: imageSlider.parent().parent().parent().find(".next"),
    prevArrow: imageSlider.parent().parent().parent().find(".prev"),
    fade: false,
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    swipeToSlide: true,
    variableWidth: true,
    centerPadding: '30px',
    touchThreshold: 1000,
  });
  
  // Function to add zero before numbers below 10
  var helpers = {
    addZeros: function (n) {
      return (n < 10) ? '0' + n : '' + n;
    }
  };

  // Hide copied slides before first one (to align slides correctly to text on page load)
  imageSlider.find('.slick-current').prev().css( 'visibility', 'hidden' );
  imageSlider.find('.slick-current').prev().prev().css( 'visibility', 'hidden' );

  imageSlider.on('afterChange', function(event, slick, currentSlide){
    // Set current slide number in counter
    imageSlider.parent().parent().parent().find('.counter .current').html(helpers.addZeros(currentSlide + 1));

    // Show hidden slides on slider interaction
    imageSlider.find('.slick-slide').prev().css( 'visibility', '' );
    imageSlider.find('.slick-slide').prev().prev().css( 'visibility', '' );
    //imageSlider.unbind('afterChange');
  });

  
}


export default imageSlider;
